import { css, styled, useTheme } from 'canoe';
import React from 'react';

import { LinkClosed, LinkOpen } from 'craft/icons';

const Button = styled.button<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    position: absolute;
    display: flex;
    align-items: flex-end;
    outline: none;
    padding: 0;
    border: none;
    background: ${theme.colors.Transparent};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
  `}
`;

const Label = styled.span<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    font-size: 9px;
    color: ${disabled ? theme.colors.GlitterGray : theme.colors.OnyxGrayL20};
    margin-right: ${theme.spaces.xxs};
  `}
`;

interface Props {
  children: React.ReactNode;
  onClick: () => void;
  isLinked?: boolean;
  className?: string;
  css?: any;
  disabled?: boolean;
}

const ValueLink = ({ children, isLinked, onClick, className, disabled }: Props) => {
  const theme = useTheme();

  return (
    <Button disabled={disabled} onClick={onClick} className={className} style={{ outline: 'none' }}>
      <Label disabled={disabled}>{children}</Label>
      {isLinked ? (
        <LinkClosed
          size={10}
          color={disabled ? theme.colors.GlitterGray : theme.colors.OnyxGrayL20}
        />
      ) : (
        <LinkOpen
          size={10}
          color={disabled ? theme.colors.GlitterGray : theme.colors.OnyxGrayL20}
        />
      )}
    </Button>
  );
};

export default ValueLink;
